import { IkeFetchableStore, IkeRequestError, IkeRequestErrorType, IkeRest } from '@ikegps/core-shared';
import { action, makeObservable } from 'mobx';
import { IkePageName } from '../page/page';
import { type IkeClientService, Services } from './index';
import { batchObservable } from './util/batch.observable';

class ObservableFetchableStore<T> implements IkeFetchableStore<T> {
	promise: Promise<T>;
	@batchObservable value: T;
	@batchObservable error: IkeRequestError;
	@batchObservable isFetching: boolean;
	@batchObservable lastFetch: number;

	constructor() {
		makeObservable(this);
	}

	@action setIsFetching(isFetching: boolean) {
		this.isFetching = isFetching;
	}

	@action setValue(value: T, lastFetch: number) {
		this.value = value;
		this.lastFetch = lastFetch;
		this.isFetching = false;
	}

	@action setError(error: IkeRequestError) {
		this.error = error;
		this.isFetching = false;
	}
}

export class IkeRestService implements IkeClientService {
	__priority = 10; // After config and log service

	rest: IkeRest;

	init() {
		IkeRest.FetchableStore = ObservableFetchableStore;
		const config = Services.Config.config;
		this.rest = IkeRest.create(config, {
			log: Services.Log.Logger,
		});

		this.rest.onError(IkeRequestErrorType.INVALID_SESSION, this.reauthenticateUser);
		this.rest.onError(IkeRequestErrorType.LICENSE_REQUIRED, this.handleNoLicenseResponse);
	}
	private reauthenticateUser() {
		Services.Route.go(IkePageName.logout);
	}

	private handleNoLicenseResponse() {
		Services.License.hasNoLicense = true;
	}
}
